import { defineComponent as _defineComponent } from 'vue'
import { useStore, useContext } from '@nuxtjs/composition-api';

import FooterMainMenu from '@/domains/menus/components/FooterMainMenu.vue';
import FooterBottomMenu from '@/domains/menus/components/FooterBottomMenu.vue';
import SocialsList from '@/components/SocialsList.vue';

interface Props {
  menuFooter?: any[];
  menuBottom?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    menuFooter: { default: () => [] },
    menuBottom: { default: () => [] }
  },
  setup(__props: any) {


const {
  $config: { joinuApp: isJoinuApp },
} = useContext();
const store = useStore();
const socialNetworks = store.getters['config/getSocials'];

return { __sfc: true,isJoinuApp, store, socialNetworks, FooterMainMenu, FooterBottomMenu, SocialsList }
}

})